
import { firebase } from "../config/firebase.client";
import { onValue, update, remove, push } from "firebase/database";
import { uploadBytesResumable, getDownloadURL, ref, deleteObject } from "firebase/storage";
import { BANNERS_ADD, BANNERS_FETCH, BANNERS_EDIT, BANNERS_REMOVE, BANNERS_ERROR } from "../store/types";
import { IBannerType } from "../types";

export const fetchBanners = () => async (dispatch: any) => {
    const { bannersRef } = firebase;
    try {
        const snapshot: any = await new Promise((resolve, reject) => {
            onValue(bannersRef, (snapshot) => {
                resolve(snapshot);
            }, {
                onlyOnce: true
            });
        });

        if (snapshot.exists()) {
            const bannersData = snapshot.val();

            const bannersArray = Object.keys(bannersData).map((key) => ({
                ...bannersData[key],
                ref: key,
            }));

            bannersArray.sort((a, b) => b.createdAt - a.createdAt);

            dispatch({
                type: BANNERS_FETCH,
                payload: bannersArray,
            });
        } else {
            throw new Error('Document not found');
        }
    } catch (error: any) {
        dispatch({
            type: BANNERS_ERROR,
            payload: error.message,
        });
    }
};
export const editBanners = (banners: IBannerType, method: "Add" | "Delete" | "Update" | "UpdateImage", img?: any) => async (dispatch: any) => {
    const { bannersAddRef, bannersEditRef, bannersImage } = firebase;

    if (method === "Add") {
        const newAdRef = push(bannersAddRef, banners);;
        const newAdData = { ...banners, ref: newAdRef.key };
        dispatch({
            type: BANNERS_ADD,
            payload: newAdData,
        });
    }
    else if (method === "Delete") {
        remove(bannersEditRef(banners.ref));



        if (banners.photoUrl) {
            const imageRef = ref(bannersImage(banners.ref));

            await deleteObject(imageRef);
        }

        dispatch({
            type: BANNERS_REMOVE,
            payload: banners,
        });
    }
    else if (method === "Update") {
        update(bannersEditRef(banners.ref), banners);

        dispatch({
            type: BANNERS_EDIT,
            payload: banners,
        });
    }
    else if (method === "UpdateImage" && img) {
        await uploadBytesResumable(bannersImage(banners.ref), img);
        let image = await getDownloadURL(bannersImage(banners.ref));


        const NewDate = {
            ...banners,
            tableData: null,
            photoUrl: image
        }

        update(bannersEditRef(banners.ref), NewDate);
        dispatch({
            type: BANNERS_EDIT,
            payload: NewDate,
        });

    }

};
